import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import EventListing from 'views/admin/events/EventListing'
import EventForm from 'views/admin/events/EventForm'
import SessionListing from './SessionListing'
import SessionForm from './SessionForm'
import TalkListing from './TalkListing'
import TalkForm from './TalkForm'

const Events = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <EventListing />
      </Route>
      <Route path={`${path}/new`}>
        <EventForm />
      </Route>
      <Route path={`${path}/edit/:eventId`}>
        <EventForm />
      </Route>
      <Route path={`${path}/:eventId/sessions/:sessionId/talks/edit/:talkId`}>
        <TalkForm />
      </Route>
      <Route path={`${path}/:eventId/sessions/:sessionId/talks/new`}>
        <TalkForm />
      </Route>
      <Route path={`${path}/:eventId/sessions/:sessionId/talks`}>
        <TalkListing />
      </Route>
      <Route path={`${path}/:eventId/talks/edit/:talkId`}>
        <TalkForm />
      </Route>
      <Route path={`${path}/:eventId/talks/new`}>
        <TalkForm />
      </Route>
      <Route path={`${path}/:eventId/talks`}>
        <TalkListing />
      </Route>
      <Route path={`${path}/:eventId/sessions/edit/:sessionId`}>
        <SessionForm />
      </Route>
      <Route path={`${path}/:eventId/sessions/new`}>
        <SessionForm />
      </Route>
      <Route path={`${path}/:eventId/sessions/`}>
        <SessionListing />
      </Route>
      <Route path={`${path}/talks/:eventId`}>
        <EventForm />
      </Route>
    </Switch>
  )
}

export default Events
